module.exports = __webpack_public_path__ + "6f28c569cfc491d8d327b7f137f7fc2a.png";